import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

/**
 * Icon for Font/Preferences.
 *
 * @file FontChange.jsx
 * @author Hari Gangadharan
 */
const FontChange = (props) => (
  // eslint-disable-next-line react/jsx-props-no-spreading
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <path
      fill="currentcolor"
      d="M13.310767,18 L3.68909709,18 L2.08682019,22.5018489 C1.98049731,22.8005797
      1.69843235,23 1.38222295,23 L0.498772198,23 C0.223307919,23 -1.42108547e-14,22.7759928
      -1.42108547e-14,22.4996659 C-1.42108547e-14,22.4423332 0.00982323007,22.3854271
      0.0290407035,22.3314326 L7.32560331,1.83059272 C7.55715997,1.17999789
      8.27063861,0.840888161 8.91920246,1.07316993 C9.27137406,1.19929945
      9.54852501,1.4773183 9.67426078,1.83059272 L15.5516441,18.3440251
      L18.0133532,11.4490578 C18.2176247,10.8769166 18.8470314,10.5786993
      19.4191726,10.7829708 C19.7298465,10.8938907 19.9743397,11.1383839
      20.0852595,11.4490578 L23.9707516,22.331879 C24.0636022,22.5919432
      23.9280489,22.8780371 23.6679848,22.9708878 C23.6140263,22.9901526 23.5571581,23
      23.4998638,23 L22.8796943,23 C22.5627065,23 22.2799472,22.8007129
      22.1733626,22.5021815 L21.6370389,21 L16.4969462,21 L16.9708234,22.3314326
      C17.0634461,22.5916705 16.9282256,22.8779556 16.6688001,22.9708684
      C16.6149741,22.990146 16.5582456,23 16.5010919,23 L15.6176411,23 C15.3014317,23
      15.0193668,22.8005797 14.9130439,22.5018489 L13.310767,18 Z M12.5989364,16
      L8.49993205,4.48320282 L4.4009277,16 L12.5989364,16 Z M17.086376,19.25
      L21.0122367,19.25 L19.0493064,13.7520554 L17.086376,19.25 Z"
    />
  </SvgIcon>
);

export default FontChange;
